import { Font } from '@react-pdf/renderer';

Font.register({
  family: 'iransans',
  src: '/fonts/iranian_sans.ttf',
});
Font.register({
  family: 'arial',
  src: '/fonts/arial.ttf',
});